import { omit } from 'ramda';

const emptyArrayProps = (currentObj) =>
  Object.keys(currentObj).filter(
    (key) => Array.isArray(currentObj[key]) && currentObj[key].length === 0
  );

const dateConverter = (date) =>
  date instanceof Date ? date.toISOString() : date;

export const converterForPlanningReports = (data) => {
  if (typeof data === 'object' && Object.keys(data).length === 0) {
    return '';
  }
  const filteredData = omit(emptyArrayProps(data), data);

  return Object.entries(filteredData)
    .map(
      ([key, value]) =>
        `${key}=${
          Array.isArray(value)
            ? value.map(dateConverter).join(',')
            : dateConverter(value)
        }`
    )
    .join('&');
};

export const parsedObject = (queryString) =>
  queryString.split('&').reduce((acc, keyValue) => {
    const [key, value] = keyValue.split('=');
    const decodedValue = decodeURIComponent(value);

    if (acc[key]) {
      if (!Array.isArray(acc[key])) {
        acc[key] = [acc[key]];
      }
      acc[key].push(decodedValue);
    } else {
      acc[key] = decodedValue;
    }

    return acc;
  }, {});
